import {
    SYMBOLS_FETCH,
    BASE_SYMBOLS_FETCH,
    SYMBOLS_IS_FETCING,
    SYMBOL_FILTER,
    SYMBOL_EDIT,
} from 'constants/symbols'

export default function symbolsReducer(state = {
    list: [],
    pageable: {
        sort: {
            'symbolId': false,
            'name': 'asc',
            'lotSize': false,
            'pipSize': false
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case SYMBOLS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case BASE_SYMBOLS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case SYMBOL_EDIT:
            return {
                ...state,
            }
        case SYMBOLS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case SYMBOL_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/symbols.js